import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  Image,
  // Image,
  Modal,
  Rate,
  Row,
  Space,
  Table,
  Typography,
} from 'antd';
import reviewApi from '../../api/review';
import PageTitle from '../../components/PageTitle';
import IntlMessage from '../../components/IntlMessage';
import FilterBar from '../../components/FilterBar';
import ActionBar from '../../components/ActionBar';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import customersApi from '../../api/customers';
import dayjs from 'dayjs';
import Status from '../../components/Status';
import { ReviewStatus } from '../../utils/constant';
import reportApi from '../../api/report';
import { fillTemplate, formatDateTime } from '../../utils/helpers';

const { Text, Paragraph } = Typography;

const actionLabelFr = {
  'Create booking': 'Création de réservation',
  'Cancel booking': 'Annulation de réservation',
  'create company': "Création d'entreprise",
  'update company': "Mise à jour d'entreprise",
  'delete company': "Suppression d'entreprise",
  'update status company': "Mise à jour du statut d'entreprise",
  'create agent': "Création d'agent",
  'update agent': "Mise à jour d'agent",
  'delete agent': "Suppression d'agent",
  'create route': "Création d'itinéraire",
  'update route': "Mise à jour d'itinéraire",
  'delete route': "Suppression d'itinéraire",
  'copy route': "Copie d'itinéraire",
  'create return route': "Création d'itinéraire retour",
  'change status route': "Mise à jour du statut d'itinéraire",
  'create segment': 'Création de segment',
  'update segment': 'Mise à jour de segment',
  'delete segment': 'Suppression de segment',
  'change status segment': 'Mise à jour du statut de segment',
  'create price segment': 'Création de tarif de segment',
  'update price segment': 'Mise à jour de tarif de segment',
  'delete price segment': 'Suppression de tarif de segment',
  'update status price segment': 'Mise à jour du statut de tarif de segment',
  'create vehicle': 'Création de véhicule',
  'update vehicle': 'Mise à jour de véhicule',
  'delete vehicle': 'Suppression de véhicule',
  'copy vehicle': 'Copie de véhicule',
  'create seat map': 'Création de plan de sièges',
  'update seat map': 'Mise à jour de plan de sièges',
  'delete seat map': 'Suppression de plan de sièges',
  'copy seat map': 'Copie de plan de sièges',
  'create payment method': 'Création de méthode de paiement',
  'update payment method': 'Mise à jour de méthode de paiement',
  'delete payment method': 'Suppression de méthode de paiement',
  'copy payment method': 'Copie de méthode de paiement',
  'update status payment method':
    'Mise à jour du statut de méthode de paiement',
  'create destination': 'Création de destination',
  'update destination': 'Mise à jour de destination',
  'delete destination': 'Suppression de destination',
  'update status destination': 'Mise à jour du statut de destination',
  'convert destination': 'Conversion de destination',
  'convert sdd destination': 'Conversion de destination SDD',
  'create collaborator': 'Création de collaborateur',
  'update collaborator': 'Mise à jour de collaborateur',
  'create user': "Création d'utilisateur",
  'update user': "Mise à jour d'utilisateur",
};

const getActionLabelFr = (action) => {
  if (!action) return '';
  return actionLabelFr[action] || action;
};

const RecentActivity = () => {
  const isMount = useRef(false);
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [condition, setCondition] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [total, setTotal] = useState(0);
  const intl = useIntl();
  const [modal, setModal] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const items = await reportApi.getAllRecentActivity(filter);
      setItems(items.data);
      setTotal(items.total);
      setLoading(false);
    }

    fetchData();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObject(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onDelete = async () => {
    await reviewApi.delete(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onApprove = async () => {
    const ids = _.filter(selectedRowKeys, (key) => {
      const review = _.find(items, (item) => Number(item.id) === Number(key));
      if (review.approved) return false;
      return true;
    });
    await reviewApi.handleApprove(ids).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] },
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };

  const onOpenModal = (record = null) => {
    setModal(true);
    setItem(record);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObject(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);
  const [form] = Form.useForm();
  const onSearch = () => {
    form.validateFields().then((values) => {
      setFilter((item) => {
        return {
          ...item,
          from_createdAt: values.from_date,
          to_createdAt: values.to_date,
        };
      });
    });
  };

  const columns = [
    {
      title: <IntlMessage id="global.no" />,
      width: 20,
      render: (text, record, index) => {
        return index + 1 + filter.limit * (filter.page - 1);
      },
    },
    {
      title: <IntlMessage id="global.action" />,
      render: (text, record, index) => {
        return getActionLabelFr(record?.action);
      },
    },
    {
      title: <IntlMessage id="global.description" />,
      render: (text, record, index) => {
        const order = record?.description && JSON.parse(record?.description);
        if (record?.action === 'Create booking') {
          return (
            <>
              <span className="gx-link">New order #{order?.order_no}</span> for{' '}
              <span className="gx-link">{order?.operator?.title}</span> was
              created at{' '}
              <span className="gx-link">
                {formatDateTime(order?.created_at)}
              </span>
            </>
          );
        } else {
          const text = fillTemplate(order?.text, {
            id: order?.recordId || order?.body?.id,
            from_date: order?.body?.from_date
              ? dayjs(order?.body?.from_date).format('DD/MM/YY HH:mm')
              : undefined,
            to_date: order?.body?.to_date
              ? dayjs(order?.body?.to_date).format('DD/MM/YY HH:mm')
              : undefined,
          });
          return (
            <>
              <span className="gx-link">{text}</span>{' '}
              <span className="gx-link">
                {formatDateTime(record?.createdAt)}
              </span>
            </>
          );
        }
      },
    },
    {
      key: 'created_by',
      title: <IntlMessage id="global.created_by" />,
      render: (record) => <Text>{record.created_by?.fullname}</Text>,
    },
    {
      key: 'created_at',
      title: <IntlMessage id="global.created_at" />,
      render: (record) => (
        <Text>{dayjs(record.createdAt).format('DD/MM/YY HH:mm')}</Text>
      ),
    },
  ];

  return (
    <>
      <Card bordered={false}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Row justify={'space-between'}>
            <Col>
              <PageTitle title={<IntlMessage id="global.recentActivity" />} />
            </Col>
            <Col>
              <ActionBar
                isShowAddButton={false}
                isShowPublishButtons={false}
                isShowCopyButton={false}
                isShowDeleteButton={false}
                onAdd={onOpenModal}
                onRefresh={onReload}
                onDelete={onDelete}
                isDisabled={!(selectedRowKeys.length > 0)}
              />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form layout="inline" form={form} onFinish={onSearch}>
                <Row justify={'start'}>
                  <Col>
                    <Form.Item
                      name="from_date"
                      dependencies={['mode', 'to_date']}
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id="global.requiredfield" />,
                        },
                      ]}>
                      <DatePicker
                        placeholder="Début"
                        format={'DD-MM-YYYY'}
                        picker={'date'}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      name="to_date"
                      dependencies={['mode', 'from_date']}
                      rules={[
                        {
                          required: true,
                          message: <IntlMessage id="global.requiredfield" />,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            console.log('value', value);
                            const fromDate = getFieldValue('from_date');

                            // Nếu chưa chọn from_date hoặc chưa chọn to_date → không lỗi
                            if (!value || !fromDate) {
                              return Promise.reject();
                            }

                            // so sánh theo ngày (bỏ phần giờ)
                            const isValid =
                              dayjs(value).isAfter(dayjs(fromDate), 'day') ||
                              dayjs(value).isSame(dayjs(fromDate), 'day');

                            if (isValid) {
                              return Promise.resolve();
                            }

                            // Nếu to_date < from_date → báo lỗi
                            return Promise.reject(
                              new Error(
                                'La date de début doit être antérieure à la date de fin.',
                              ),
                            );
                          },
                        }),
                      ]}>
                      <DatePicker
                        placeholder="Fin"
                        format={'DD-MM-YYYY'}
                        picker={'date'}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Chercher
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          {/* searchbar */}
          <Flex vertical gap={8}>
            <FilterBar onFilter={onFilter} playholderSearch="Utilisateur" />
          </Flex>
          <br />

          <Table
            scroll={{ x: 'max-content' }}
            tableLayout="auto"
            columns={columns}
            dataSource={items}
            loading={loading}
            rowSelection={rowSelection}
            rowKey="id"
            size="small"
            onChange={onChangeTable}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              total: total,
              current: filter.page,
              pageSize: filter.limit,
            }}
          />
        </Space>
      </Card>
    </>
  );
};

export default RecentActivity;
